module.exports = __webpack_public_path__ + "img/6.fec9e6de.jpg";